import React from 'react'
import { Text, View } from 'react-native'
import {
  BG_STYLES,
  BUTTON_STATUS,
  Button,
  BUTTON_TYPE,
  COLORS,
  COMMON_STYLES,
  CrossIcon,
  SIZE,
  TEXT_STYLES,
} from '@dehaat/dds'
import { useTranslation } from 'react-i18next'
import ApproveIcon from 'app/icons/Approve'
import { DemoMaterialRequest } from 'app/models/RequestFlow'
import SalesOrderChip from './SalesOrderChip'

type Props = {
  item: DemoMaterialRequest
  styles: any
  isApprovedRequest: boolean
  isApprovedByYou: boolean
  isMultiSelectEnabled: boolean
  showApproverActions: boolean
  onRejectRequest: (item: DemoMaterialRequest) => void
  onApproveRequest: (item: DemoMaterialRequest) => void
}

const DemoRequestCardFooter = ({
  item,
  styles,
  isApprovedRequest,
  isApprovedByYou,
  isMultiSelectEnabled,
  showApproverActions,
  onRejectRequest,
  onApproveRequest,
}: Props) => {
  const { t } = useTranslation()

  return (
    <>
      {isApprovedRequest ? (
        <View style={styles.saleOrderWrap}>
          {isApprovedByYou ? (
            <View style={styles.approvedByYouWrap}>
              <ApproveIcon width={16} height={16} color={COLORS.success100} />
              <Text style={styles.approvedByYouText}>{t('demo_approved_by_you')}</Text>
            </View>
          ) : (
            <View style={COMMON_STYLES.flex1} />
          )}
          <SalesOrderChip request={item} />
        </View>
      ) : null}
      {!isMultiSelectEnabled && showApproverActions && (
        <View style={[COMMON_STYLES.row, COMMON_STYLES.mt1, { gap: 12 }]}>
          <Button
            buttonStyle={[BG_STYLES.bgError10, styles.actionBtn]}
            onClick={() => onRejectRequest(item)}
            type={BUTTON_TYPE.PRIMARY}
            text={t('reject')}
            size={SIZE.small}
            status={BUTTON_STATUS.ACTIVE}
            textStyle={[TEXT_STYLES.textError100]}
            iconLeft={<CrossIcon height={16} width={16} strokeColor="error100" />}
          />
          <Button
            buttonStyle={[BG_STYLES.bgPrimary10, styles.actionBtn]}
            onClick={() => onApproveRequest(item)}
            type={BUTTON_TYPE.PRIMARY}
            text={t('approve')}
            size={SIZE.small}
            status={BUTTON_STATUS.ACTIVE}
            textStyle={[TEXT_STYLES.textPrimary100]}
            iconLeft={<ApproveIcon width={16} height={16} color={COLORS.primary100} />}
          />
        </View>
      )}
    </>
  )
}

export default DemoRequestCardFooter
